/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A filter option for a chart (e.g., product filter)
 * @export
 * @interface ChartFilterOptionDto
 */
export interface ChartFilterOptionDto {
    /**
     * Value to send when this option is selected
     * @type {string}
     * @memberof ChartFilterOptionDto
     */
    value: string;
    /**
     * Display label for this option
     * @type {string}
     * @memberof ChartFilterOptionDto
     */
    label: string;
}

/**
 * Check if a given object implements the ChartFilterOptionDto interface.
 */
export function instanceOfChartFilterOptionDto(value: object): value is ChartFilterOptionDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ChartFilterOptionDtoFromJSON(json: any): ChartFilterOptionDto {
    return ChartFilterOptionDtoFromJSONTyped(json, false);
}

export function ChartFilterOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartFilterOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
    };
}

export function ChartFilterOptionDtoToJSON(json: any): ChartFilterOptionDto {
    return ChartFilterOptionDtoToJSONTyped(json, false);
}

export function ChartFilterOptionDtoToJSONTyped(value?: ChartFilterOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
    };
}

